import { Theme } from "@mui/material";
import i18n from "locales/i18n";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ScheduleIcon from "@mui/icons-material/Schedule";
import moment from "moment";

import { Booking } from "../../../types";

const tc = i18n.getFixedT(null, "calendar");
// Booking-level meeting status (Phase 2) → label + color + icon. "completed"
// is derived (a confirmed meeting whose end time has passed).
export const meetingStatusMeta = (booking: Booking, theme: Theme) => {
  switch (booking.status) {
    case "cancelled":
      return {
        label: tc("meeting_status.cancelled"),
        color: theme.palette.error.main,
        Icon: CancelOutlinedIcon,
      };
    case "pending":
      return {
        label: tc("meeting_status.pending"),
        color: theme.palette.warning.main,
        Icon: ScheduleIcon,
      };
    case "confirmed": {
      const end = moment(`${booking.date} ${booking.to}`, "YYYY-MM-DD HH:mm");
      return end.isValid() && end.isBefore(moment())
        ? {
            label: tc("meeting_status.completed"),
            color: theme.palette.info.main,
            Icon: CheckCircleIcon,
          }
        : {
            label: tc("meeting_status.confirmed"),
            color: theme.palette.success.main,
            Icon: CheckCircleIcon,
          };
    }
    default:
      return null;
  }
};
